import Config from "services/config/config";
import callWebService, {
  callTypes
} from "services/utils/networks/network";
import { CREATE_TICKET } from "./type";

export const createTicket = (data) => async (dispatch) => {
  try {
    const res = await callWebService(
      callTypes.post,
      data,
      `${Config.employeeTickets.createTicket}`
    );

    if (res) {
      const { data } = res;
      dispatch({
        type: CREATE_TICKET,
        payload: data,
      });
      return true;
    }
  }
  catch {
    dispatch({
      type: CREATE_TICKET,
      payload: null,
    });
    return true;
  }
};